import styled from 'styled-components';

const ShareStyle = styled.div`
	--padRightShare: var(--sp3-5x);
	--distanceShare: var(--sp2x);
	--mediaShareSize: var(--sp5x);
	--distanceLink: var(--sp3x);
	--iconSize: var(--sp4x);

	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	column-gap: var(--distanceShare);

	.wrapper-link {
		display: flex;
		gap: var(--distanceLink);
	}

	.link-item {
		will-change: transform;
		transition: transform var(--trTime) ease-out;
		line-height: 1;

		i {
			line-height: 1;
			font-size: var(--iconSize);
		}
	}

	.media-share {
		cursor: pointer;
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.link-item {
				&:hover {
					transform: scale(1.2);
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--iconSize: var(--sp4x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--iconSize: calc(var(--sp3x) + var(--sp0-5x));
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--iconSize: var(--sp3x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;

export default ShareStyle;
